import { combineReducers } from 'redux';
import target from './reducers/target';
import map from './reducers/map';

export default combineReducers({
  target: target,
  map: map,
});